/**
 * DEFINIR SENHA de uma portaria SEM e-mail (26/10/2026). Sem e-mail não há link de "esqueci a senha": quem criou define
 * uma nova. Serve ao escritório (ficha do cliente) e ao síndico (Equipe, no Portal) — cada um passa a sua função de
 * salvar. A senha digitada é a que vale (decisão do Matheus: sem troca obrigatória).
 */
import { useState } from 'react';

import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, ErroCampo, Input, Label } from '@/components/ui';

interface Props {
  aberta: boolean;
  nome: string;
  usuario: string | null;
  aoFechar: () => void;
  /** Salva a senha; lança com a frase do servidor quando recusa. */
  salvar: (senha: string) => Promise<void>;
  aoSalvar: () => void;
}

export function DefinirSenhaPortalDialog({ aberta, nome, usuario, aoFechar, salvar, aoSalvar }: Props) {
  const [senha, setSenha] = useState('');
  const [repetida, setRepetida] = useState('');
  const [erro, setErro] = useState<{ senha?: string; repetida?: string; geral?: string }>({});
  const [salvando, setSalvando] = useState(false);

  function fechar() {
    setSenha('');
    setRepetida('');
    setErro({});
    aoFechar();
  }

  async function confirmar() {
    if (senha.length < 8) {
      setErro({ senha: 'A senha precisa de pelo menos 8 caracteres.' });
      document.getElementById('senha-portal-nova')?.focus();
      return;
    }
    if (senha !== repetida) {
      setErro({ repetida: 'As duas senhas estão diferentes.' });
      document.getElementById('senha-portal-repetida')?.focus();
      return;
    }
    setErro({});
    setSalvando(true);
    try {
      await salvar(senha);
      setSenha('');
      setRepetida('');
      aoSalvar();
    } catch (e) {
      setErro({ geral: e instanceof Error && e.message ? e.message : 'Não deu para salvar agora. Tente de novo.' });
    } finally {
      setSalvando(false);
    }
  }

  return (
    <Dialog open={aberta} onOpenChange={(o) => !o && fechar()} size="sm">
      <DialogHeader>
        <DialogTitle>Definir senha</DialogTitle>
      </DialogHeader>
      <DialogContent>
        <div className="flex flex-col gap-3">
          <p className="text-sm text-ink-2 dark:text-ink-dark-2">
            {nome}
            {usuario ? (
              <>
                {' '}· usuário <strong>{usuario}</strong>
              </>
            ) : null}
            . Passe a senha nova para a portaria: ela vale a partir de agora.
          </p>
          <div>
            <Label htmlFor="senha-portal-nova">Senha nova</Label>
            <Input id="senha-portal-nova" type="password" autoComplete="new-password" value={senha} onChange={(e) => setSenha(e.target.value)} error={erro.senha} />
          </div>
          <div>
            <Label htmlFor="senha-portal-repetida">Repita a senha</Label>
            <Input id="senha-portal-repetida" type="password" autoComplete="new-password" value={repetida} onChange={(e) => setRepetida(e.target.value)} error={erro.repetida} />
          </div>
          <ErroCampo id="senha-portal-geral" mensagem={erro.geral} />
        </div>
      </DialogContent>
      <DialogFooter>
        <Button variant="ghost" onClick={fechar} disabled={salvando}>
          Cancelar
        </Button>
        <Button onClick={() => void confirmar()} loading={salvando} data-testid="senha-portal-salvar">
          Salvar senha
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
